'use strict';

angular.module('imagetrend.components')
    .controller('EducationReportModalController', ['$scope', '$rootScope', '$uibModalInstance', 'topic', 'Topics', 'TrainingLocations', 'TrainingFields', 'Upload', 'FileTypes', 'Trainings', 'parameters', "Levels", function ($scope, $rootScope, $uibModalInstance, topic, Topics, TrainingLocations, TrainingFields, Upload, FileTypes, Trainings, parameters, Levels) {
        $scope.selectedTopic = topic;
        $scope.file = null;
        $scope.locationsLoading = true;
        $scope.documentsLoading = true;
        $scope.addCourse = new Object();
        $scope.saving = false;
        $scope.showWarning = false;

        $scope.getTopicOptions = function (training_topic, index) {
            if (training_topic.topicID) {
                Topics.get({ supplementalOnly: true, topicID: training_topic.topicID }).then(function (topic) {
                    if (topic.length > 0 && topic[0].options) {
                        var temp = topic[0].options.split(',');
                        var checkBoxOptions = [];
                        temp.forEach(function (value) {
                            checkBoxOptions.push({ value: value, checked: false });
                        })
                        $scope.addCourse.courseTopics[index].options = checkBoxOptions;
                    }
                    else {
                        $scope.addCourse.courseTopics[index].options = null;
                    }
                })
            }
        }

        Levels.getEducationVerificationDates({ userID: parameters.user_id, applicationTypes: parameters.license_id }).then(function (dates) {
            $scope.startDate = Date.parse(dates.startDate);
            $scope.endDate = Date.parse(dates.endDate);
        });

        if ($scope.addCourse.courseTopics == null) {
            $scope.addCourse.courseTopics = [];
            $scope.addCourse.courseTopics.push({ $$hashKey: $scope.selectedTopic.$$hashKey, options: [], topicID: $scope.selectedTopic.id });
            $scope.getTopicOptions({ topicID: $scope.selectedTopic.id }, 0);
        }

        $scope.checkDate = function () {
            // start & end Dates are in UTC, turn current completedOn datetime to UTC
            var date = new Date(new Date($scope.addCourse.completedOn).setHours(new Date().getUTCHours(), new Date().getMinutes()));
            $scope.showWarning = ($scope.startDate <= date && date <= $scope.endDate) ? false : true;
        }

        Topics.get({ supplementalOnly: true }).then(function (topics) {
            $scope.topics = topics;
        })

        TrainingLocations.get().then(function (locations) {
            if (locations != null) {
                $scope.locations = locations;
            }
            $scope.locationsLoading = false;
        })

        TrainingFields.get().then(function (fields) {
            if (fields != null) {
                $scope.fields = fields.records;
                // Set location required flag for proper validation
                var locationField = $scope.fields.find(function(f) { return f.alias === 'self_entered_location'; });
                $scope.locationRequired = locationField ? (locationField.fieldRequired === true) : false;
                // For the 'needed' string attribute, we need to pass "required" or not set it at all
                $scope.locationNeededAttr = $scope.locationRequired ? 'required' : undefined;
            }
        })

        FileTypes.getByEnterprise().then(function (data) {
            if (data != null && data.length > 0) {
                $scope.extensions = data.toString();
            } else {
                $scope.extensions = "'*'";
            }
            $scope.documentsLoading = false;
        });

        $scope.locationChange = function () {
            if ($scope.selectedTopic.trainingLocation != null) {
                if (isValidGuid($scope.selectedTopic.trainingLocation.id)) {
                    $scope.addCourse.locationId = $scope.selectedTopic.trainingLocation.id;
                }
                else {
                    $scope.addCourse.locationId = null;
                }
            }
        }

        $scope.remove = function (array, item) {
            array.splice(array.indexOf(item), 1);
        }

        $scope.fileChange = function () {
            if (!$scope.working) {
                $scope.uploading = false;
            }
        }

        $scope.fileUpdated = function (file) {
            if (file != null) {
                $scope.working = true;
                Upload.base64DataUrl(file).then(function (content) {
                    $scope.addCourse.certificate = {
                        fileContent: content,
                        fileName: file.name,
                        fileSize: file.size
                    }
                    $scope.working = false;
                    $scope.uploading = false;
                })
            }
            else {
                $scope.uploading = false;
            }
        }

        $scope.filePicked = function () {
            $scope.uploading = true;
        }

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.save = function () {
            $scope.saving = true;
            var userID = null;
            if (parameters.user_id) {
                userID = parameters.user_id;
            } else {
                userID = $rootScope.userID;
            }
            $scope.addCourse.userId = userID;
            $scope.addCourse.licenseRequestId = parameters.license_request_id;

            $scope.addCourse.courseTopics.forEach(function (topic) {
                var selectedOptions;
                if (topic.options && topic.options.length > 0) {
                    selectedOptions = "";
                    topic.options.forEach(function (option) {
                        if (option.checked == true) {
                            selectedOptions = selectedOptions + "," + option.value;
                        }
                    })
                    if (selectedOptions != "") {
                        selectedOptions = selectedOptions.substring(1, selectedOptions.length);
                        topic.selectedOptions = selectedOptions;
                    }
                }
            })

            // Save these dates at midnight (00:00:00 does not display a time) and in UTC. Switch to UTC from local for UTC conversion going to back-end #277825.
            var picked = new Date($scope.addCourse.completedOn);
            $scope.addCourse.completedOn = new Date(Date.UTC(picked.getFullYear(), picked.getMonth(), picked.getDate(), 0, 0, 0, 0));
            if ($scope.addCourse.optionalStartDate) {
                picked = new Date($scope.addCourse.optionalStartDate);
                $scope.addCourse.optionalStartDate = new Date(Date.UTC(picked.getFullYear(), picked.getMonth(), picked.getDate(), 0, 0, 0, 0));
            }

            Trainings.postCourseUserSummary($scope.addCourse).then(function (result) {
                $uibModalInstance.close($scope.addCourse);
            });
        }
    }])
    ;
